module.exports = __webpack_public_path__ + "static/computer_it-6153d93716e6e0018e9177c9eb0c7499.jpg";